import {h, Component} from 'preact';
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants from '../constants';
import designService from '../service/designService';
import util from "../util";
import ConfigureTemplateModal from "./ConfigureTemplateModal";
import Spinner from "./Spinner";
import designDomain from "../domain/designDomain";
import MoveCopyTemplateModal from "./MoveCopyTemplateModal";

export default @connect(reduce, actions)
class Promos extends Component {
  constructor() {
    super();

    this.state = {
      designers: [],
      page: 0,
      pageSize: 100,
      typeFilter: '',
      assignedToFilter: '',
      searchByFilter: '',
      orderByFilter: 'name',
      freeFilter: '',
      designToConfigure: '',
      end: false,
      selected: [],
      designsToConfigure: [],
      isSelectionMode: false,
    };

    this.useTemplate = this.useTemplate.bind(this);
    this.editTemplate = this.editTemplate.bind(this);
    this.finalRemoveTemplate = this.finalRemoveTemplate.bind(this);
    this.removeTemplate = this.removeTemplate.bind(this);
    this.restoreTemplate = this.restoreTemplate.bind(this);
    this.updateStatus = this.updateStatus.bind(this);
    this.infiniteLoadTemplates = this.infiniteLoadTemplates.bind(this);
    this.onConfigureTemplateModalClose = this.onConfigureTemplateModalClose.bind(this);
    this.getTemplates = this.getTemplates.bind(this);
    this.removeFromList = this.removeFromList.bind(this);
    this.onChangeTypeFilter = this.onChangeTypeFilter.bind(this);
    this.onChangeAssignedToFilter = this.onChangeAssignedToFilter.bind(this);
    this.onChangeSearchByFilter = this.onChangeSearchByFilter.bind(this);
    this.onChangeOrderByFilter = this.onChangeOrderByFilter.bind(this);
    this.showConfigureTemplateModal = this.showConfigureTemplateModal.bind(this);
    this.onChangeStatusFilter = this.onChangeStatusFilter.bind(this);
    this.changeStatus = this.changeStatus.bind(this);
    this.onChangeFreeFilter = this.onChangeFreeFilter.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);
    this.toggleSelected = this.toggleSelected.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.deselectAll = this.deselectAll.bind(this);
    this.showConfigureTemplateModalMultiple = this.showConfigureTemplateModalMultiple.bind(this);
    this.showMoveCopyTemplateModal = this.showMoveCopyTemplateModal.bind(this);
    this.onMoveCopyTemplateModalClose = this.onMoveCopyTemplateModalClose.bind(this);
  }

  onChangeStatusFilter(ev) {
    this.props.setStatusFilter(ev.target.value);
  }

  changeStatus(design) {
    design.isChangingStatus = true;
  }

  scrollToTop() {
    $(".promos-scroller").animate({scrollTop: 0}, "fast");
  }

  showConfigureTemplateModal(design) {
    if (this.state.isSelectionMode) return;
    this.setState(() => ({designToConfigure: design.id, designsToConfigure: []}));
    setTimeout(() => {
      this.props.showConfigureTemplateModal();
    }, 100);
  }

  showConfigureTemplateModalMultiple() {
    this.setState(() => ({ designToConfigure: null, designsToConfigure: this.state.selected }));
    setTimeout(() => {
      this.props.showConfigureTemplateModal();
    }, 100);
  }

  showMoveCopyTemplateModal() {
    this.setState(() => ({ designsToConfigure: this.state.selected }));
    setTimeout(() => {
      this.props.showMoveCopyTemplateModal();
    }, 100);
  }

  onMoveCopyTemplateModalClose() {
    this.props.hideMoveCopyTemplateModal();
  }

  onChangeTypeFilter(ev) {
    this.setState(() => ({typeFilter: ev.target.value}));
  }

  onChangeAssignedToFilter(ev) {
    this.setState(() => ({assignedToFilter: ev.target.value}));
  }

  onChangeSearchByFilter(ev) {
    this.setState(() => ({searchByFilter: ev.target.value}));
  }

  onChangeOrderByFilter(ev) {
    this.setState(() => ({orderByFilter: ev.target.value}));
  }

  onChangeFreeFilter(ev) {
    this.setState(() => ({freeFilter: ev.target.value}));
  }

  removeFromList(id) {
    const designs = this.props.promoDesigns.slice(0).filter(it => it.id !== id);
    this.props.setPromoDesigns(designs);
  }

  getTemplates() {
    this.setState(() => ({page: 0, end: false}));
    this.deselectAll();

    const filters = {
      page: this.state.page,
      pageSize: this.state.pageSize,
      status: this.props.statusFilter,
      sizeType: this.state.typeFilter,
      search: this.state.searchByFilter,
      assignedTo: this.state.assignedToFilter,
      orderBy: this.state.orderByFilter,
      orderByDirection: this.state.orderByFilter === 'name' ? 'asc' : 'desc',
      free: this.state.freeFilter,
    };

    this.props.setPromoDesigns([], true);
    designService.getTemplates(filters).then(response => {
      const designs = response.data.map(design => new designDomain.Design(design, util.sizes));
      this.props.setPromoDesigns(designs);
    })
  }

  onConfigureTemplateModalClose() {
    this.props.hideConfigureTemplateModal();
  }

  infiniteLoadTemplates() {
    let top = $('.promos-scroller').scrollTop();
    if (this.state.end) return;

    if (top >= $(".cards").height() - $(".promos-scroller").height() - 100) {
      if (!this.props.promoDesignsLoading) {
        const page = this.state.page + 1;
        this.setState(() => ({page}));

        const filters = {
          page,
          pageSize: this.state.pageSize,
          status: this.props.statusFilter,
          sizeType: this.state.typeFilter,
          search: this.state.searchByFilter,
          assignedTo: this.state.assignedToFilter,
          orderBy: this.state.orderByFilter,
          orderByDirection: this.state.orderByFilter === 'name' ? 'asc' : 'desc',
        };

        this.props.setPromoLoading(true);

        designService.getTemplates(filters).then(response => {
          const newDesigns = response.data.map(design => new designDomain.Design(design, util.sizes));
          if (newDesigns.length > 0) {
            let designs = this.props.promoDesigns;
            this.props.setPromoDesigns(designs.concat(newDesigns));
          } else {
            this.setState(() => ({end: true}));
          }
          this.props.setPromoLoading(false);
        })
      }
    }
  }

  updateStatus(design, status) {
    this.props.setIsSaved(false);
    this.props.setIsSaving(true);

    designService.updateDesign({
      id: design.id,
      status: status,
    }).then(() => {
      this.props.setIsSaved(true);
      this.props.setIsSaving(false);

      design.status = status;
      design.isChangingStatus = false;
      this.forceUpdate();
    })
  }

  useTemplate(design) {
    if (this.state.isSelectionMode) return;
    if (this.props.isAdmin || this.props.isDesigner) {
      this.editTemplate(design);
      return
    }
    window.location = constants.appPrefix + '/design?parentId=' + design.id;
  }

  editTemplate(design) {
    window.location = constants.appPrefix + '/design?id=' + design.id
  }

  finalRemoveTemplate(design) {
    window.ConfirmationModal.show({
      title: `Hard removing <b>${design.name}</b>`,
      body: 'Are you extra certain?',
      acceptLabel: 'Yes',
      declineLabel: 'No',
      onAccept: () => {
        designService.finalRemoveDesign(design.id).then(() => {
          this.removeFromList(design.id);
        })
      },
      onDecline: () => {
        window.ConfirmationModal.hide();
      }
    })
  }

  removeTemplate(design) {
    if (design.status !== 'draft') return;

    window.ConfirmationModal.show({
      title: 'Removing <b>' + design.name + '</b>',
      body: 'Are you extra certain?',
      acceptLabel: 'Yes',
      declineLabel: 'No',
      onAccept: () => {
        designService.removeDesign(design.id).then(() => {
          this.removeFromList(design.id)
        })
      },
      onDecline: () => {
        window.ConfirmationModal.hide()
      }
    })
  }

  restoreTemplate(design) {
    window.ConfirmationModal.show({
      title: 'Restoring <b>' + design.name + '</b>',
      body: 'Are you extra certain?',
      acceptLabel: 'Yes',
      declineLabel: 'No',
      onAccept: () => {
        designService.restoreDesign(design.id).then(() => {
          this.removeFromList(design.id)
        })
      },
      onDecline: () => {
        window.ConfirmationModal.hide()
      }
    })
  }

  componentDidMount() {
    this.setState({page: 0});
    this.deselectAll();

    if (this.state.designers.length === 0) {
      designService.getDesigners().then(response => {
        if (!response || !response.data) return;
        this.setState({designers: response.data})
      })
    }
  }

  closePromos() {
    this.deselectAll();
    this.props.hidePromos();
  }

  toggleSelected(ev, design) {
    ev.stopPropagation();
    const $target = $(ev.target);
    const isCheckbox = ($target.hasClass('checkbox') || $target.parent().hasClass('checkbox'));
    if (this.state.isSelectionMode || isCheckbox) {
      if (this.state.selected.includes(design)) {
        if (this.state.selected.length === 1) {
          this.setState({ isSelectionMode: false });
        }
        let selectedCopy = [...this.state.selected];
        let index = selectedCopy.indexOf(design);
        selectedCopy.splice(index, 1);
        this.setState({ selected: selectedCopy });
      } else {
        if (this.state.selected.length === 0) {
          this.setState({ isSelectionMode: true });
        }
        this.setState({ selected: [...this.state.selected, design] });
      }
      if (!isCheckbox) {
        let checkbox = $target.closest('.design-card').find('.checkbox input');
        checkbox.prop('checked', !checkbox.prop('checked'));
      }
    }
  }

  selectAll() {
    $('.design-card').each(function() {
      let checkbox = $(this).find('.checkbox input');
      checkbox.prop('checked', true);
    });
    let toSelect = [];
    this.props.promoDesigns.forEach(function(design) {
      toSelect.push(design);
    })
    this.setState({ selected: toSelect, isSelectionMode: true });
  }

  deselectAll() {
    $('.design-card').each(function() {
      let checkbox = $(this).find('.checkbox input');
      checkbox.prop('checked', false);
    });
    this.setState({ selected: [], isSelectionMode: false });
  }

  render(props, state) {
    let templates = props.promoDesigns;
    let content = (props.promoDesignsLoading && templates.length === 0 ? <Spinner/> : <p>No matches found.</p>);

    if (templates.length > 0) {
      content = templates.map(design => {
        let removeTemplateElement = null;
        if (props.isAdmin || props.isDesigner) {
          if (design.removed) {
            removeTemplateElement = <a style="margin-left: 5px" className={'btn sm'} onClick={() => this.finalRemoveTemplate(design)}>Hard Remove</a>;
          } else if (design.status === 'draft') {
            removeTemplateElement = <a style="margin-left: 5px" className={'btn sm'} onClick={() => this.removeTemplate(design)}>Remove</a>;
          }
        }

        let restoreElement = null;
        if ((props.isAdmin || props.isDesigner) && design.removed) {
          restoreElement = <a style="margin-left: 5px" className={'btn sm'} onClick={() => this.restoreTemplate(design)}>Restore</a>;
        }

        let statusElement = null;
        if (props.isAdmin || props.isDesigner || props.isWriter) {
          if (design.isChangingStatus) {
            statusElement = constants.statuses.map(status =>
              <span className={'tag ' + status.id + (!props.isAdmin && status.forAdmin ? ' hidden' : '')} onClick={() => this.updateStatus(design, status.id)}>{status.label}</span>
            )
          } else {
            statusElement = (
              <span style="margin-left: 0" className={'tag ' + design.status} onClick={() => this.changeStatus(design)}>{!design.status ? '' : util.getStatusLabel(design.status)}</span>
            )
          }
        }

        const thumb = (util.isBusinessCard(design.size) || util.isLoyaltyCard(design.size) || util.isCommentCard(design.size) ||
          util.isGiftCertificate(design.size) || util.isRackCard(design.size) || util.isTakeout(design.size) ||
          util.isFoldedMenu(design.size) || util.isHalfPageMenu(design.size) || util.isTableTent(design.size) ||
          util.isTableTentInsert(design.size) || util.isSticker(design.size) || util.isLabel(design.size)) && design.pageCount > 1 ?
          <div className="img-wrap">
            <div class="checkbox" onClick={(ev) => this.toggleSelected(ev, design)}>
              <input type="checkbox"></input>
            </div>
            <img className={util.isPortraitCard(design.size) || util.isHalfPageMenu(design.size) ||
            util.isTableTent(design.size) || util.isTableTentInsert(design.size) ? 'portrait-bc' : ''} onClick={() => this.useTemplate(design)}
                 src={design.defaultThumbnailPath}/>
            <img className={util.isPortraitCard(design.size) || util.isHalfPageMenu(design.size) ||
            util.isTableTent(design.size) || util.isTableTentInsert(design.size) ? 'portrait-bc' : ''} onClick={() => this.useTemplate(design)}
                 src={design.defaultThumbnailPath.replace("-p1", "-p2")}/>
          </div>
          : <div className="img-wrap">
            <div class="checkbox" onClick={(ev) => this.toggleSelected(ev, design)}>
              <input type="checkbox"></input>
            </div>
            <img onClick={() => this.useTemplate(design)} src={design.defaultThumbnailPath}/>
          </div>;

        return (
          <div className={"design-card" + (state.isSelectionMode ? " select-mode" : "") + (state.selected.includes(design) ? " selected" : "")} onClick={(ev) => this.toggleSelected(ev, design)}>
            <div className="content">
              {thumb}
              <h6>{design.sizeLabel}</h6>
              <h5>
                <a onClick={() => this.useTemplate(design)}>
                  {design.free ? '' : <img src={'https://musthavemenus.com/imageservice/images/img/13/pay-modal/Pro2.svg'} alt={''}/>}
                  {design.name}
                </a>
                <br/>
                {statusElement}
              </h5>
              <div className="actions">
                <a className="btn sm" onClick={() => this.showConfigureTemplateModal(design)}>Configure</a>
                {removeTemplateElement}
                {restoreElement}
              </div>
            </div>
          </div>
        )
      })
    }

    let statuses = [];
    if (props.isAdmin) statuses = constants.statuses;
    else if (props.isDesigner) statuses = constants.designerStatuses;
    else if (props.isWriter) statuses = constants.writerStatuses;

    let statusOptions = statuses.map(status =>
      <option key={status.id} value={status.id} className="">{status.label}</option>
    );

    const sizeTypes = [...new Set(util.sizes.map(size => size.label))];
    const typesOptions = sizeTypes.map(size =>
      <option value={size} className="">{size}</option>
    );

    const assignedToOptions = this.state.designers.length > 0 ? this.state.designers.map(designer =>
      <option key={designer} value={designer}>{designer}</option>
    ) : '';

    const anyStatusOption = props.isAdmin ? <option value="" selected>Select a status...</option> : null;

    return props.isPromosVisible ? (
      <div id="promos">
        <div className="content">
          <h2 style="margin-bottom: 1rem;">Browse Designs</h2>

          <div className="filters">
            <div className="form-block">
              <select value={props.statusFilter} onChange={this.onChangeStatusFilter}>
                {anyStatusOption}
                {statusOptions}
              </select>

              <select value={state.typeFilter} onChange={this.onChangeTypeFilter}>
                <option value="" selected>All sizes...</option>
                {typesOptions}
              </select>

              <select value={state.assignedToFilter} onChange={this.onChangeAssignedToFilter}>
                <option value="" selected>Assigned to...</option>
                {assignedToOptions}
              </select>

              <input onKeyUp={this.onChangeSearchByFilter} type="text" placeholder="Search by..."/>

              <select value={state.orderByFilter} onChange={this.onChangeOrderByFilter}>
                <option value="createdDate" selected>Order by create date</option>
                <option value="updatedDate">Order by last update date</option>
                <option value="rank">Order by rank</option>
                <option value="name">Order by label</option>
              </select>

              <select value={props.freeFilter} onChange={this.onChangeFreeFilter}>
                <option value="">--</option>
                <option value="true">Free</option>
                <option value="false">Pro</option>
              </select>

              <a className="btn" onClick={this.getTemplates}>search</a>
              <div className="select-link" onClick={() => this.selectAll()}>Select All</div>
              <div className="select-link" onClick={() => this.deselectAll()}>Deselect All</div>
            </div>
          </div>

          <a className="btn close" onClick={() => this.closePromos()}>Close</a>

          <div className="promos-scroller" onScroll={this.infiniteLoadTemplates}>
            <div className="cards">{content}</div>
            {props.promoDesignsLoading && templates.length > 0 && <Spinner/>}
          </div>
        </div>

        <a className="btn scroll-to-top" onClick={this.scrollToTop}>back to top</a>
        {state.isSelectionMode &&
        <div className="bulk-configure-bar">
          <div onClick={() => this.showConfigureTemplateModalMultiple()}>Configure Selected ({state.selected.length})</div>
          <div onClick={() => this.showMoveCopyTemplateModal()}>Move or Copy Selected ({state.selected.length})</div>
        </div>}

        <ConfigureTemplateModal open={props.isConfigureTemplateModal} designToConfigure={state.designToConfigure} onModalClose={this.onConfigureTemplateModalClose} selectedDesigns={state.designsToConfigure}/>

        <MoveCopyTemplateModal open={props.isMoveCopyTemplateModal} selectedDesigns={state.designsToConfigure} onModalClose={this.onMoveCopyTemplateModalClose} admin={props.isAdmin} promoDesigns={props.promoDesigns} getTemplates={this.getTemplates}></MoveCopyTemplateModal>
      </div>
    ) : null
  }
}
